<template>
  <el-form :model="fistFormData" :rules="fistFormRules" ref="fistFormRef" label-width="120px">
    <el-row :gutter="24">
      <el-col :span="6">
        <el-form-item label="公司代码" prop="storageCompanyCode">
          <el-input
            disabled
            v-model="fistFormData.storageCompanyCode"
            placeholder="请输入公司代码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="公司名称" prop="storageCompanyName">
          <el-input
            disabled
            v-model="fistFormData.storageCompanyName"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="部门" prop="storageDepartmentCode">
          <el-select
            v-model="fistFormData.storageDepartmentCode"
            :disabled="isReadonly || !isUpdateStatus"
            placeholder="请选择部门"
            @change="changeDepartmentHandler"
          >
            <el-option
              v-for="(item, index) of departmentList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input
            disabled
            v-model="fistFormData.storageDepartmentCode"
            placeholder="请输入公司名称"
          ></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="创建时间" prop="createdAt">
          <el-date-picker
            disabled
            v-model="fistFormData.createdAt"
            placeholder="请选择创建时间"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="一级编码" prop="storageCode">
          <el-input disabled v-model="fistFormData.storageCode" placeholder="自动生成"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="创建人" prop="storageCreatePersonName">
          <SearchTable
            searchType="personnel"
            :isMultiple="true"
            :disabled="status != 'create' || isReadonly || isUpdateStatus"
            :currentValue="fistFormData.storageCreatePersonName"
            @input="chooseTableHandler"
          ></SearchTable>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="业务负责人" prop="personInChargeCode">
          <SearchTable
            searchType="personnel"
            isMultiple
            @input="selectPersonInChargeHandler"
            :disabled="isReadonly || !isUpdateStatus"
            :currentValue="fistFormData.personInCharge"
          ></SearchTable>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="审核状态" prop="currentStatus">
          <el-input v-model="currentStatusStr" disabled placeholder="自动生成" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系人" prop="contactPerson">
          <el-input
            v-model="fistFormData.contactPerson"
            placeholder="请输入联系人"
            :disabled="isReadonly || !isUpdateStatus"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="联系电话" prop="contactTelephone">
          <el-input
            v-model="fistFormData.contactTelephone"
            placeholder="请输入联系电话"
            :disabled="isReadonly || !isUpdateStatus"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="一级名称" prop="storageName">
          <el-input
            v-model="fistFormData.storageName"
            placeholder="请输入一级名称"
            :disabled="isReadonly || !isUpdateStatus"
            @change="checkStoreNameBlurHandler"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否专库" prop="isSpecial">
          <el-select
            v-model="fistFormData.isSpecial"
            placeholder="请选择是否专库"
            :disabled="isReadonly || !isUpdateStatus"
            style="width: 100%"
          >
            <el-option :value="0" label="否"></el-option>
            <el-option :value="1" label="是"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="仓库类型" prop="storageType">
          <el-select
            v-model="fistFormData.storageTypeCode"
            placeholder="请选择仓库类型"
            style="width: 100%"
            :disabled="isReadonly || !isUpdateStatus"
            @change="changeStorageTypeHandle"
          >
            <el-option
              v-for="(item, index) of storeType"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否实体" prop="isReality">
          <el-select
            v-model="fistFormData.isReality"
            placeholder="请选择是否实体"
            style="width: 100%"
            :disabled="isReadonly || !isUpdateStatus"
          >
            <el-option
              v-for="(item, index) of entityList"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="省" prop="provinceCode">
          <el-select
            filterable
            v-model="fistFormData.provinceCode"
            @change="changeProvinceHandler"
            placeholder="请选择省"
            clearable
            @clear="clearProvinceHandler"
            style="width: 100%"
            :disabled="isReadonly || !isUpdateStatus"
          >
            <el-option
              v-for="item of provinceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="市" prop="cityCode">
          <el-select
            filterable
            v-model="fistFormData.cityCode"
            placeholder="请选择市"
            clearable
            :disabled="isDisabledCity || isReadonly || !isUpdateStatus"
            @clear="clearCityHandler"
            style="width: 100%"
          >
            <el-option
              v-for="item of cityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="是否库位管理" prop="hasLocation">
          <el-select
            filterable
            v-model="fistFormData.hasLocation"
            placeholder="是否库位管理"
            :disabled="isReadonly || !isUpdateStatus"
            style="width: 100%"
          >
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细地址" prop="storageAddress">
          <el-input
            v-model="fistFormData.storageAddress"
            placeholder="请输入详细地址"
            :disabled="isReadonly || !isUpdateStatus"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="存放品种" prop="storageVariety">
          <el-select
            v-model="fistFormData.storageVariety"
            :disabled="isReadonly || !isUpdateStatus"
            placeholder="请选择存放品种"
            style="width: 100%"
            multiple
          >
            <el-option
              v-for="(item, index) of storageVariety"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex';
  import { fistFormRules } from './rules';
  import { yesNoList, entityList, storageVariety } from '@/constants';
  import SearchTable from '@/components/form-item/search-table';
  import BASE_API from '@/api/dataBase';
  import API from '@/api/masterData/cooperation.js';
  import storeMixin from './../../../storeMixin.js';
  export default {
    name: 'FormData',
    mixins: [storeMixin],
    props: {
      // 表格数据
      formData: {
        type: Object,
        default: () => {},
      },
      // 是否只读
      isReadonly: {
        type: Boolean,
        default: false,
      },
      isUpdateStatus: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        yesNoList,
        entityList,
        fistFormRules,
        storageVariety,
        status: '',
        departmentList: [], // 部门列表
        fistFormData: {
          companyCode: '',
          companyName: '',
          storageCompanyCode: '',
          storageCompanyName: '',
          storageDepartmentCode: '',
          storageDepartmentName: '',
          personInCharge: '',
          createdAt: '',
          storageCode: '',
          personInChargeCode: '',
          contactPerson: '',
          contactTelephone: '',
          storageName: '',
          isSpecial: '',
          storageType: '',
          isReality: '',
          provinceCode: '',
          cityCode: '',
          hasLocation: '',
          storageAddress: '',
          storageVariety: '',
        },
        cityList: [],
        isDisabledCity: true,
      };
    },
    methods: {
      // 初始化部门列表
      async initDepartment(companyCode) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          this.departmentList = data.data?.personDepartmentInfo.map((item) => {
            return {
              label: item.personDepartmentName,
              value: item.personDepartmentCode,
            };
          });
        } else {
          console.error('获取部门失败');
        }
      },
      changeStorageTypeHandle(value) {
        const currentItem = this.storeType.find((v) => v.value == value);
        this.fistFormData = {
          ...this.fistFormData,
          storageTypeCode: value,
          storageType: currentItem.label,
        };
      },
      // 切换部门
      changeDepartmentHandler(value) {
        console.log(value, '111?');
        const currentItem = this.departmentList.find((item) => item.value == value);
        this.fistFormData = {
          ...this.fistFormData,
          storageDepartmentCode: value,
          storageDepartmentName: currentItem.label,
        };
      },
      // 切换省份
      changeProvinceHandler(value, isInit = false) {
        if (!isInit) {
          this.fistFormData = {
            ...this.fistFormData,
            cityCode: '',
          };
        }
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
            this.isDisabledCity = false;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      clearProvinceHandler() {
        this.fistFormData = {
          ...this.fistFormData,
          provinceCode: '',
          cityCode: '',
        };
        this.isDisabledCity = true;
      },
      clearCityHandler() {
        this.fistFormData = {
          ...this.fistFormData,
          cityCode: '',
        };
      },
      // 选择人员下拉框
      selectPersonInChargeHandler(row) {
        this.fistFormData = {
          ...this.fistFormData,
          personInChargeCode: row[0]?.personNo,
          personInCharge: row[0].personName,
        };
      },
      chooseTableHandler(row) {
        this.fistFormData = {
          ...this.fistFormData,
          storageCreatePersonNo: row[0]?.personNo,
          storageCreatePersonName: row[0].personName,
        };
      },
      // 校验一级名称是否重复
      async checkStoreNameBlurHandler(ev) {
        this.checkStoreName(ev, '一');
      },
      validate(fn) {
        this.$refs.fistFormRef.validate((valid) => {
          if (valid) {
            delete this.fistFormData.createdAt;
            // delete this.fistFormData.storageCode;
            console.log(this.fistFormData, '提交数据');
            fn && fn(this.fistFormData);
          }
        });
      },
      // 获取创建人
      _initUserList() {
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            this.requestByList = res.data.data.personInfo;
          }
        });
      },
    },
    mounted() {
      this._initUserList();
      this.status = this.$route.query?.status;
      if (this.$route.query?.status == 'create') {
        this.fistFormData = {
          ...this.fistFormData,
          storageCreatePersonNo: this.userInfo.userCode,
          storageCreatePersonName: this.userInfo.personName,
          storageCompanyName: this.userInfo.companyName,
          storageCompanyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          storageDepartmentCode: this.userInfo.departmentCode,
          storageDepartmentName: this.userInfo.departmentName,
          createdAt: +new Date(),
        };
        this.initDepartment(this.userInfo.companyCode);
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        provinceList(state) {
          return state.dict?.dictList?.find((it) => it.dictType == 'province')?.dictList;
        },
      }),
      storeType() {
        let list = this.$baseRequest.getDictListMapByType('storage_type');
        return list;
      },
    },
    watch: {
      formData: {
        handler: function (newVal) {
          console.log(newVal, '-获取到的数据--');
          if (newVal && Object.keys(newVal).length) {
            const {
              personInCharge,
              storageCode,
              personInChargeCode,
              contactPerson,
              contactTelephone,
              storageName,
              isSpecial,
              storageType,
              isReality,
              provinceCode,
              cityCode,
              storageAddress,
              storageVariety,
              storageCompanyCode,
              storageCompanyName,
              storageCreatePersonName,
              storageCreatePersonNo,
              storageDepartmentCode,
              storageDepartmentName,
              id,
              gmtCreate,
              companyCode,
              companyName,
              hasLocation,
            } = newVal;
            this.fistFormData = {
              ...this.fistFormData,
              storageCompanyCode,
              storageCompanyName,
              storageDepartmentCode,
              storageDepartmentName,
              personInCharge,
              storageCode,
              personInChargeCode,
              contactPerson,
              contactTelephone,
              storageName,
              isSpecial,
              storageType,
              isReality,
              provinceCode,
              cityCode,
              storageAddress,
              id,
              storageCreatePersonName,
              storageCreatePersonNo,
              createdAt: gmtCreate,
              storageVariety: storageVariety?.split(','),
              companyCode,
              companyName,
              hasLocation: hasLocation + '',
            };
            this.changeProvinceHandler(provinceCode, true);
            this.initDepartment(storageCompanyCode);
            console.log(this.fistFormData.storageVariety, '111赋值1', this.fistFormData);
          }
        },
        immediate: true,
        deep: true,
      },
    },
    components: {
      SearchTable,
    },
  };
</script>

<style lang="scss" scoped>
  .isShowLabel {
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
</style>
